module.exports = __webpack_public_path__ + "static/media/horizontal-distribution-center.4e0b4b6d.svg";